// frontend/src/config.js
export const IS_PAYMENTS_ENABLED = process.env.REACT_APP_ENABLE_PAYMENTS === 'true';